/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    em: "em"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "/faunus/"
  }, React.createElement(_components.em, null, "Faunus")), ", the literary journal of ", React.createElement(_components.em, null, "The Friends"), ", has appeared twice yearly since the inauguration. Contents regularly include both articles of interest to admirers of Machen and examples of his work, often articles and pieces not easily available elsewhere."), "\n", React.createElement(_components.p, null, React.createElement(_components.em, null, "Machenalia"), ", our newsletter, also appears twice yearly. It is more informal, less literary in tone and style, dealing with items of topical interest, about Machen, and about ", React.createElement(_components.em, null, "The Friends"), "."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
